import i18n, { createI18nProperty } from '@/i18n'
import { TAB_CATEGORY } from '../../constant/permission'
import RootLayout from './layout/rootLayout'
import BlankLayout from './layout/blankLayout'
import AsideLayout from './layout/asideLayout'
import companyAdminRoute from './companyAdmin/route'
import talentPoolRoute from './talentPool/route'
import jobRoute from './job/route'
import applicationRoute from './application/route'
import customerRoute from './customer/route'

const routes = [
  {
    name: 'talentSearchLayout',
    path: '/talent-search',
    component: AsideLayout,
    meta: {
      permission: TAB_CATEGORY.TALENT_SEARCH,
      get title () {
        return i18n.t('admin.talent.search.title')
      },
      tab: {
        get label () {
          return i18n.t('admin.talent.search.tab')
        },
        customClass: ['search-candidate']
      }
    },
    children: []
  },
  talentPoolRoute,
  {
    name: 'universalApplicationListLayout_oldRoute',
    path: '/v-admin/application-old',
    redirect: '/v-admin/application',
    component: BlankLayout,
    meta: {
      isInclude: true,
      permission: ['PERM_VIEW_UNIVERSAL_APPLICATION_LIST', 'PREMIUM_HR_DASHBOARD'],
      titleI18nKey: 'admin.application.applicantList.title.list',
      tab: {
        get label () {
          return i18n.t('admin.application.applicantList.tab')
        }
      }
    }
  },
  {
    name: 'companyJobLayout',
    path: '/company-job-view',
    redirect: '/v-admin/job-list/',
    component: BlankLayout,
    meta: {
      isInclude: true,
      permission: TAB_CATEGORY.JOB,
      get title () {
        return i18n.t('admin.jobList.title')
      },
      tab: {
        get label () {
          return i18n.t('admin.jobList.tab')
        },
        customClass: ['job']
      }
    },
    children: jobRoute
  },
  applicationRoute,
  {
    name: 'interviewArrangementLayout',
    path: '/interview-arrangement',
    component: AsideLayout,
    meta: {
      permission: TAB_CATEGORY.INTERVIEW,
      get title () {
        return i18n.t('admin.interview.title')
      },
      tab: {
        get label () {
          return i18n.t('admin.interview.tab')
        }
      }
    },
    children: []
  },
  {
    path: '/referral/status-referral-management',
    component: AsideLayout,
    meta: {
      permission: TAB_CATEGORY.REFERRAL,
      get title () {
        return i18n.t('admin.referral.title')
      },
      tab: {
        get label () {
          return i18n.t('admin.referral.tab')
        }
      }
    },
    children: []
  },
  companyAdminRoute,
  customerRoute,
  {
    name: 'CRMManagementLayoutOld',
    path: '/v-admin/crm-management_old',
    redirect: '/v-admin/crm-management',
    meta: {
      isInclude: true,
      permission: {
        strict: false,
        isMatchAnd: true,
        any: [
          ['PERM_MICROSITE_CAMPAIGN_MANAGEMANT', 'PREMIUM_MICROSITE_CAMPAIGN_MANAGEMENT'],
          ['PERM_CANDIDATE_SURVEY_MANAGEMENT', 'PREMIUM_PREFERENCE_SURVEY_MANAGEMENT'],
          ['PERM_TAG_MANAGEMANT', 'PREMIUM_TAG_MANAGEMENT']
        ]
      },
      titleI18nKey: 'admin.crm.title.management',
      tab: {
        get label () {
          return i18n.t('admin.crm.tab')
        }
      }
    },
    children: []
  },
  {
    name: 'chatBotManagement',
    path: '/v-admin/chatbot-management',
    redirect: '/v-admin/chatbot-management/index',
    component: BlankLayout,
    meta: {
      permission: TAB_CATEGORY.CHAT_BOT,
      get title () {
        return i18n.t('admin.chatBot.title')
      },
      tab: {
        get label () {
          return i18n.t('admin.chatBot.tab')
        }
      }
    },
    children: []
  },
  // {
  //   name: 'chartReportLayout',
  //   path: '/chart-report-home',
  //   component: BlankLayout,
  //   meta: {
  //     permission: TAB_CATEGORY.CHART_REPORT,
  //     get title () {
  //       return i18n.t('admin.chartReport.title')
  //     },
  //     tab: {
  //       get label () {
  //         return i18n.t('admin.chartReport.tab')
  //       }
  //     }
  //   },
  //   children: []
  // },
  // 这个页面更新了，新的页面在adminNew文件夹
  // hrDashboardRoute,
  {
    name: 'hrDashboardRoute',
    path: '/v-admin/hr-dashboard/',
    redirect: '/v-admin/hr-dashboard/index',
    component: BlankLayout,
    meta: {
      isInclude: true,
      permission: ['PERM_HR_DASHBOARD', 'PREMIUM_HR_DASHBOARD'],
      titleI18nKey: 'admin.hrDashboard.title',
      tab: createI18nProperty({
        contentStyle: {
          background: '#f7f7f7',
          padding: '40px'
        }
      }, 'label', 'admin.hrDashboard.tab')
    }
  },
  {
    name: 'rpaRoute',
    path: '/v-admin/rpa',
    redirect: '/v-admin/rpa/index',
    component: BlankLayout,
    meta: {
      isInclude: true,
      permission: ['PERM_RPA_MANAGEMENT', 'PREMIUM_RPA_MANAGEMENT'],
      titleI18nKey: 'RPA',
      tab: createI18nProperty({
        contentStyle: {
          background: '#f7f7f7',
          padding: '40px'
        }
      }, 'label', 'admin.rpa.tab')
    }
  },
  {
    name: 'APSchedulerRoute',
    path: '/v-admin/ap-scheduler',
    redirect: '/v-admin/ap-scheduler/index',
    component: BlankLayout,
    meta: {
      isInclude: true,
      permission: ['PERM_RPA_MANAGEMENT', 'PREMIUM_RPA_MANAGEMENT'],
      titleI18nKey: 'admin.apScheduler.tab.index',
      tab: createI18nProperty({
        contentStyle: {
          background: '#f7f7f7',
          padding: '40px'
        }
      }, 'label', 'admin.apScheduler.tab.index')
    }
  }
]

export default {
  name: 'adminRootLayout',
  path: '',
  component: RootLayout,
  meta: {
    isRootLayout: true
  },
  children: routes
}

export const allLayoutRoutes = routes
